import io from "socket.io-client";

class SocketWorker {
  constructor(companyId, userId) {
    if (!SocketWorker.instance) {
      this.companyId = companyId;
      this.userId = userId;
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {};
      SocketWorker.instance = this;
    }
    return SocketWorker.instance;
  }

  getToken() {
    try {
      const raw = localStorage.getItem("token");
      return raw ? JSON.parse(raw) : "";
    } catch {
      return "";
    }
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/workspace-${this?.companyId}`, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
      transports: ["websocket", "polling"],
      upgrade: true,
      pingTimeout: 30000,
      pingInterval: 25000,
      query: { userId: this.userId, token: this.getToken() }
    });

    // Atualiza o token antes de cada tentativa de reconnect (caso token tenha sido renovado)
    this.socket.io.on("reconnect_attempt", () => {
      this.socket.io.opts.query = { userId: this.userId, token: this.getToken() };
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
    });

    this.socket.on("connect_error", (err) => {
      console.warn("Socket connect_error:", err.message);
    });
  }

  on(event, callback) {
    this.connect();
    this.socket.on(event, callback);
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  off(event, callback) {
    this.connect();
    if (this.eventListeners[event]) {
      if (callback) {
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      SocketWorker.instance = null;
      console.log("Socket desconectado manualmente");
    }
  }

  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {
    if (this.socket) {
      this.socket.io.opts.query = { userId: this.userId, token: this.getToken() };
      this.socket.disconnect().connect();
    }
  }
}

const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;
